module.exports = __webpack_public_path__ + "static/gallery_yarra_2_thumb-52750d96ee364759ae551bca7f7c7a1d.jpg";